export const defaultPropsToFilter = [
    "theme",
    "size",
    "variation",
    "variant",
    "isLoading",
    "state",
];
const filterProps = (obj, keys = defaultPropsToFilter) => {
    const res = {};
    Object.keys(obj).forEach((key) => {
        if (!keys.includes(key)) {
            res[key] = obj[key];
        }
    });
    return res;
};
export default filterProps;
